"use client";

import { Html, If } from "@/Components";
import { CenterOptions } from "@/Helpers/CenterOptions";
import { DoctorsSectionProps } from "@/Templates/SectionsProps";
import { Col, Row } from "antd";
import { FC, useMemo } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import Slider from "react-slick";
import { DoctorItem } from "../Components";

interface ArrowProps {
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
}

const CustomNextArrow: FC<ArrowProps> = ({ onClick }) => (
  <div className="spciality-nav nav-bottom owl-nav">
    <button
      type="button"
      role="presentation"
      className="owl-next"
      onClick={onClick}
    >
      <FaChevronRight />
    </button>
  </div>
);

const CustomPrevArrow: FC<ArrowProps> = ({ onClick }) => (
  <div className="spciality-nav nav-bottom owl-nav">
    <button
      type="button"
      role="presentation"
      className="owl-prev"
      onClick={onClick}
    >
      <FaChevronLeft />
    </button>
  </div>
);

const LegacyDoctorsSection: FC<DoctorsSectionProps> = ({
  setting,
  dataSource,
}) => {
  const doctorOptions = {
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    infinite: true,
    focusOnSelect: true,
    nextArrow: <CustomNextArrow />,
    prevArrow: <CustomPrevArrow />,
    responsive: [
      { breakpoint: 576, settings: { slidesToShow: 1 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 992, settings: { slidesToShow: 3 } },
      { breakpoint: 1200, settings: { slidesToShow: 4 } },
    ],
  };

  const content = useMemo(() => {
    switch (setting.ItemsDisplayMode?.Key) {
      case CenterOptions.SiteTemplate.SiteTemplateSettings.ItemsDisplayMode
        .Slider.key:
        return (
          <>
            <div
              className="doctors-slider slick-margins slick-arrow-center aos"
              data-aos="fade-up"
            >
              <Slider {...doctorOptions}>
                {dataSource.Items.map((item) => (
                  <DoctorItem key={item.CenterUserId} model={item} />
                ))}
              </Slider>
            </div>
            <div className="doctor-nav nav-bottom owl-nav" />
          </>
        );
      default:
        return (
          <Row gutter={[8, 8]}>
            {dataSource.Items.map((item) => (
              <Col key={item.CenterUserId} xs={24} md={6}>
                <DoctorItem model={item} />
              </Col>
            ))}
          </Row>
        );
    }
  }, [dataSource.Items, setting.ItemsDisplayMode?.Key]);

  const isBlueTickedDoctorsSection =
    setting.OnlyBlueTickedDoctorsStatus?.Key ===
    CenterOptions.Enum.Status.Active.key;

  return (
    <section
      className={`doctor-section${
        isBlueTickedDoctorsSection ? " doctor-section-blue-ticked" : ""
      }`}
    >
      <div className="container">
        <If condition={!!setting.Title || !!setting.Description}>
          <div
            className="section-header sec-header-one text-center aos"
            data-aos="fade-up"
          >
            {setting.Title && (
              <span className="badge badge-primary">{setting.Title}</span>
            )}
            {setting.Description && (
              <h2>
                <Html value={setting.Description} />
              </h2>
            )}
          </div>
        </If>
        {content}
      </div>
    </section>
  );
};

export default LegacyDoctorsSection;
